<template>
    <div 
        class="view-default-sidebar__container"
        :class="{'view-default-sidebar__container_closing': !isOpen && !isSmallWindow}"
    >
        <transition name="fade">
            <img-container
                v-if="isOpen && !isSmallWindow"
                :lazySrc="logoSrc"
                :lazySrcset="logoSrc2x"
                :width="105"
                :height="52"
            />
        </transition>
        <sidebar 
            :sidebarItems="sidebarItems"
            :isOpen="isOpen"
            :isSmallWindow="isSmallWindow"
            :tooltipPosition="isSmallWindow ? 'bottom' : 'right'"
        />
        <div class="view-default-sidebar__plug"></div>
        <button
            v-if="!isSmallWindow"
            class="view-default-sidebar__btn"
            :class="{'view-default-sidebar__btn_closing': !isOpen}"
            @click="onToggle"
        >
            <i class="view-default-sidebar__btn-icon icon-chevron-down" />
        </button>
    </div>
</template>

<script>
import Sidebar from '../../components/Sidebar/Sidebar';
import ImgContainer from '../../components/Base/ImgContainer';
import mixinAdaptive from '../../mixins/mixinAdaptive';
import schemeSidebar from '../../schemes/schemeSidebar';
let {sidebarItems} = schemeSidebar;
export default {
    name: 'ViewDefaultSidebar',
    mixins: [
        mixinAdaptive
    ],
    components: {
        Sidebar,
        ImgContainer
    },
    /**
     * Данные компонента
     * @property {array} sidebarItems - элементы сайдбара
     * @property {boolean} isOpen - режим сайдбара
     */
    data: () => ({
        isOpen: true,
        sidebarItems: sidebarItems
    }),
    computed: {
        /**
         * путь к логотипу
         * @returns {string}
         */
        logoSrc() {
            return require("../../assets/images/logo.png");
        },
        /**
         * путь к логотипу
         * @returns {string}
         */
        logoSrc2x() {
            return require("../../assets/images/logo@2x.png");
        }
    },
    methods: {
        /**
         * переключение режима сайдбара
         */
        onToggle() {
            this.isOpen = !this.isOpen;
        }
    }
}
</script>

<style lang="scss" scoped>
    .fade-enter-active {
        transition: opacity 0.3s ease-in;
    }
    .fade-enter {
        opacity: 0;
    }
    .view-default-sidebar__container {
        box-sizing: border-box;
        width: 240px;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 3px 25px;
        transition: width 0.3s;
    }
    .view-default-sidebar__container_closing {
        width: 60px;
        padding: 3px 5px;
    }
    .view-default-sidebar__plug {
        flex: 1;
    }
    .view-default-sidebar__btn {
        height: 40px;
        width: 40px;
        color: #b0b1b4;
        background: transparent;
        padding: 0;
        border: 1px solid #f1f3f5;
        transform: rotate(90deg);
        border-radius: 100px;
        transition: .3s;
        white-space: nowrap;
        cursor: pointer;
        margin: 10px 0 20px auto;
        outline: none;
    }
    .view-default-sidebar__btn_closing {
        transform: rotate(-90deg);
        margin: 10px auto;
    }
    .view-default-sidebar__btn:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .view-default-sidebar__btn-icon {
        font-size: .6154rem;
    }
</style>